import "./App.scss";
// TODO We need to gradually fade out react bootstrap and use prime reacts
import "primereact/resources/themes/bootstrap4-light-blue/theme.css";  //theme
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css";
// TODO make this imported as a sass file (Refer node_modules for this package)
import "primeflex/primeflex.min.css";
import React from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "./pages/auth/LoginAuthSlice";
import loadable from '@loadable/component';
// import LoginPage from './pages/auth/login/LoginPage';
import RequireAuth from "./components/required-auth/RequiredAuth";
import { CLIENT_ROUTES, CONNECT_POA_URL, EMPLOYEE_LOGIN, HOME_ROUTE } from "./config/routes";
import EmployeeLogin from "./pages/auth/employee/EmployeeLogin";
import { displayPagesAsPerUser } from "./utilities/pageDisplayPerUser";
import { CLIENT_DEPARTMENTS, EMPLOYEE_DEPARTMENTS } from "./config/departments";
import Login from "./pages/auth/login/Login"
// import ForgotPassword from "./pages/auth/login/forgot-password/ForgotPassword";
// import RecoverPassword from "./pages/auth/login/recover-password/RecoverPassword";
// import ExcelFile from "./components/outlook/outlook-graph/ExcelFile";
// import SelectDirectory from "./components/outlook/outlook-graph/select-directory/SelectDirectory";
// import EmailSent from "./pages/auth/login/components/EmailSent";
// import PasswordGenerated from "./pages/auth/login/components/PasswordGenerated";
import CenteredSpinner from "./components/centered-spinner/CenteredSpinner";
import OnboardingPage from "./pages/onboarding/OnboardingPage";



const options = {
  fallback: <CenteredSpinner />
}
const SelectDirectory = loadable(() => import(/* webpackChunkName: "SelectDirectory" */ "./components/outlook/outlook-graph/select-directory/SelectDirectory"), options)
const DashboardLayout = loadable(() => import(/* webpackChunkName: "DashboardLayout" */ "./layouts/dashboard/DashboardLayout"), options)
const ClientDashboardLayout = loadable(() => import(/* webpackChunkName: "ClientDashboardLayout" */ "./layouts/dashboard/clinet-dasboard-home/ClientDashboardLayout"), options)
const Page404 = loadable(() => import(/* webpackChunkName: "Page404" */ "./pages/page404/Page404"), options);
const EmailSent = loadable(() => import(/* webpackChunkName: "EmailSent" */ "./pages/auth/login/components/EmailSent"), options);
const PasswordGenerated = loadable(() => import(/* webpackChunkName: "PasswordGenerated" */ "./pages/auth/login/components/PasswordGenerated"), options);
const ForgotPassword = loadable(() => import(/* webpackChunkName: "ForgotPassword" */ "./pages/auth/login/forgot-password/ForgotPassword"), options);
const RecoverPassword = loadable(() => import(/* webpackChunkName: "RecoverPassword" */ "./pages/auth/login/recover-password/RecoverPassword"), options);


const LAYOUT_MAP = {
  [CLIENT_DEPARTMENTS.CLIENT]: <ClientDashboardLayout />,
  // [USER_DEPARTMENT.OPERATIONS]: <DashboardLayout />,
  // [USER_DEPARTMENT.SUPER_ADMIN]: <DashboardLayout />,
  [EMPLOYEE_DEPARTMENTS.CLIENT_SERVICES]: <DashboardLayout />,
  // [USER_DEPARTMENT.SALES]: <DashboardLayout />,
  [EMPLOYEE_DEPARTMENTS.SALES]: <DashboardLayout />,
  [EMPLOYEE_DEPARTMENTS.KNOWLEDGE_MANAGEMENT]: <DashboardLayout />
}
function App() {

  const loggedInUser = useSelector(selectUser)
  const { department, designation } = loggedInUser

  return (
    <Routes>
      {/* * The below route is left on purpose, please don't remove. */}
      {/* <Route path="/excel" element={<ExcelFile />} /> */}
      <Route path={CONNECT_POA_URL} element={<SelectDirectory />} />
      {/* <Route path={CLIENT_LOGIN} element={<LoginPage />} /> */}
      <Route path={CLIENT_ROUTES.CLIENT_LOGIN} element={<Login />} />
      <Route path={CLIENT_ROUTES.CLIENT_FORGOT_PASSWORD} element={<ForgotPassword />} />
      <Route path={CLIENT_ROUTES.RESET_PASSWORD} element={<RecoverPassword />} />
      <Route path={CLIENT_ROUTES.EMAIL_SENT} element={<EmailSent />} />
      <Route path={CLIENT_ROUTES.PASSWORD_RESET_SUCCESS} element={<PasswordGenerated />} />
      <Route path={EMPLOYEE_LOGIN} element={<EmployeeLogin />} />

      {/* These routes are protected by authentication, Pages like Dashboard etc should be defined under here */}
      <Route element={<RequireAuth />}>
        {/*example <Route path="/protected" element={<ProtectedPage />} /> */}
      <Route path="/onboarding-users" element={<OnboardingPage />} />
        <Route path={HOME_ROUTE} element={LAYOUT_MAP[department ?? CLIENT_DEPARTMENTS.CLIENT]}>
          {displayPagesAsPerUser(department, designation)}
          <Route path="*" element={< Page404 />} />
        </Route>

        {/* Matcher for when no routes match. This must always be in the end cause of the wildcard * character */}
      </Route>
    </Routes>
  );
}

export default App;
